export default {
    strict: true,
    fields: {
        name: {
            type: "string",
        },
    },
};
